@use "../../styles/breakpoint.module" as *;
@use "../../styles/layout.module" as l;

.count {
    composes: fontST16 from "../../styles/typography.module.scss";
    grid-column: content;
    margin-bottom: var(--spacer-24);
}

.videos {
    composes: listReset from "../../styles/utils.module.scss";
    grid-column: content;
    display: grid;

    --max-size: 22%;

    grid-template-columns: repeat(auto-fill, minmax(var(--max-size), 1fr));
    gap: var(--spacer-40) var(--spacer-gutter);

    @media ($below-tablet) {
        --max-size: 30%;
    }

    @media ($below-mobile) {
        --max-size: 45%;

        column-gap: var(--spacer-16);
    }

    img {
        width: 100%;
        margin-bottom: var(--spacer-16);
    }
}

.card {
    composes: base from "../Clickables/index.module.scss";
    position: relative;
    display: block;
}

.tag {
    composes: fontP12 from "../../styles/typography.module.scss";
    position: absolute;

    --pad: var(--spacer-8);

    top: var(--pad);
    left: var(--pad);
    padding: var(--spacer-4) var(--spacer-8);
    border-radius: var(--border-radius-sm);
    background-color: var(--red);
    color: var(--white);
}

.title {
    composes: fontSH24 from "../../styles/typography.module.scss";
}
